import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import * as FreudDS from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { SafePipeModule } from 'app/pipes/safe.pipe.module';

import { SupersetEmbedModule } from '../../app/superset/superset-embed.module';
import { InsightsClariSugestionsModule } from './components/insights-clari-sugestions/insights-clari-sugestions.module';
import { InsightsPageComponent } from './components/insights-page/insights-page.component';

@NgModule({
	declarations: [InsightsPageComponent],
	imports: [
		CommonModule,
		FreudDS.FreudTypographyModule,
		TranslateModule.forChild(),
		SafePipeModule,
		InsightsClariSugestionsModule,
		FreudDS.FreudCardModule,
		SupersetEmbedModule,
	],
	providers: [],
	entryComponents: [InsightsPageComponent],
})
export class InsightsModule {}
